import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import styles from './AudioBubble.scss';
import { AudioPlayer, Box } from 'wix-style-react';
import withAppMode from '../../../providers/appMode/withAppMode';
import StatusAlert from 'wix-ui-icons-common/StatusAlert';
import withTheme from '../../../providers/theme/withTheme';
import { withTranslation } from 'react-i18next';
import { ErrorBoundary } from '../../ErrorBoundary/ErrorBoundary';
var AudioBubble = /** @class */ (function (_super) {
    __extends(AudioBubble, _super);
    function AudioBubble(props) {
        var _this = _super.call(this, props) || this;
        _this.handleAudioLoad = function () {
            _this.setState({ isLoading: false });
        };
        _this.handleAudioError = function (event) {
            var _a, _b;
            console.error('inbox: could not load audio', (_b = (_a = _this.props.messagePart) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.uri, event);
            _this.setState({ hasError: true, isLoading: false });
        };
        _this.state = {
            isLoading: true,
            hasError: false,
        };
        return _this;
    }
    AudioBubble.prototype.render = function () {
        var _a;
        var _b, _c;
        var _d = this.props, messagePart = _d.messagePart, transit = _d.transit, t = _d.t, _e = _d.PlayerComponent, PlayerComponent = _e === void 0 ? AudioPlayer : _e;
        var _f = this.state, isLoading = _f.isLoading, hasError = _f.hasError;
        var isPending = transit && transit.isPending;
        var format = (_c = (_b = messagePart.mimeType) === null || _b === void 0 ? void 0 : _b.split('/')) === null || _c === void 0 ? void 0 : _c[1];
        var src = messagePart.data.uri;
        if (!src) {
            return null;
        }
        return hasError ? (React.createElement(Box, { direction: "vertical", verticalAlign: "middle", className: styles.audioError, dataHook: "audio-error-container" },
            React.createElement(StatusAlert, null),
            React.createElement("span", { className: styles.errorText }, t('this.content.is.unavailable')))) : (React.createElement("div", { className: classnames((_a = {},
                _a[styles.audioWrapper] = true,
                _a[styles.audioPending] = isPending,
                _a)), "data-hook": "audio-container", tabIndex: -1 },
            React.createElement(ErrorBoundary, { displayName: "Audio Player" },
                React.createElement(PlayerComponent, { dataHook: "chat-message-audio-player", onLoad: this.handleAudioLoad, className: styles.audio, src: src, onLoadError: this.handleAudioError, format: format })),
            (isPending || isLoading) && !hasError ? (React.createElement("div", { "data-hook": "loader", className: styles.pending },
                React.createElement("div", { className: styles.loader }))) : null));
    };
    return AudioBubble;
}(React.Component));
export default withAppMode(withTheme(withTranslation()(AudioBubble)));
//# sourceMappingURL=AudioBubble.js.map